export default __webpack_public_path__ + "static/media/s0_female.0d58435a.wav";